var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg062Next(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.28994 20.71C9.47771 20.8993 9.7333 21.0058 9.99994 21.0058C10.2666 21.0058 10.5222 20.8993 10.7099 20.71L18.7099 12.71C18.8971 12.5213 19.0015 12.2658 18.9999 12C19.0015 11.7342 18.8971 11.4787 18.7099 11.29L10.7099 3.29003C10.4563 3.03637 10.0866 2.9373 9.74006 3.03015C9.39356 3.12299 9.12291 3.39364 9.03006 3.74015C8.93722 4.08665 9.03628 4.45637 9.28994 4.71003L16.5899 12.01L9.28994 19.29C9.10063 19.4778 8.99414 19.7334 8.99414 20C8.99414 20.2667 9.10063 20.5223 9.28994 20.71Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg062Next);
export default __webpack_public_path__ + "static/media/062-next.de5b8e7c1bc578fbbf93fa7ead8fe40c.svg";
export { ForwardRef as ReactComponent };